
const digest = '331ba6727c83122f67c28bedb2157941d36bf0596ae10811cad4fae2f13b94b6';
const classes = {"item":"_item_5ga25_1","patient":"_patient_5ga25_8","patientImage":"_patientImage_5ga25_16","patientData":"_patientData_5ga25_21","title":"_title_5ga25_26","text":"_text_5ga25_31","contentItem":"_contentItem_5ga25_35","lightGrey":"_lightGrey_5ga25_42","extra":"_extra_5ga25_47","name":"_name_5ga25_51","content":"_content_5ga25_35","red":"_red_5ga25_89","orange":"_orange_5ga25_97","green":"_green_5ga25_101","controls":"_controls_5ga25_105","link":"_link_5ga25_116"};
const css = `._item_5ga25_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_5ga25_1 ._patient_5ga25_8 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 12px 24px;
  gap: 10px;
  min-width: 350px;
  max-width: 350px;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientImage_5ga25_16 {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientData_5ga25_21 {
  display: flex;
  gap: 12px;
  flex-direction: column;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientData_5ga25_21 ._title_5ga25_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientData_5ga25_21 ._text_5ga25_31 {
  color: #3e3f42;
  font-size: 14px;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientData_5ga25_21 ._contentItem_5ga25_35 {
  font-size: 14px;
  color: #000000;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._item_5ga25_1 ._patient_5ga25_8 ._patientData_5ga25_21 ._contentItem_5ga25_35 ._lightGrey_5ga25_42 {
  color: #9ea0a5;
  font-weight: 400;
  min-width: 140px;
}
._item_5ga25_1 ._patient_5ga25_8 ._extra_5ga25_47 {
  display: flex;
  gap: 40px;
}
._item_5ga25_1 ._patient_5ga25_8 ._extra_5ga25_47 ._name_5ga25_51 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_5ga25_1 ._patient_5ga25_8 ._extra_5ga25_47 ._name_5ga25_51 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_5ga25_1 ._content_5ga25_35 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  gap: 7px;
}
._item_5ga25_1 ._content_5ga25_35 ._extra_5ga25_47 {
  display: flex;
  gap: 40px;
}
._item_5ga25_1 ._content_5ga25_35 ._title_5ga25_26 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._item_5ga25_1 ._content_5ga25_35 ._name_5ga25_51 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_5ga25_1 ._content_5ga25_35 ._name_5ga25_51 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_5ga25_1 ._content_5ga25_35 ._red_5ga25_89 {
  color: #c53127;
  font-weight: 600;
}
._item_5ga25_1 ._content_5ga25_35 ._red_5ga25_89 span {
  color: #c53127;
  font-weight: 600;
}
._item_5ga25_1 ._content_5ga25_35 ._orange_5ga25_97 span {
  color: #f18200;
  font-weight: 600;
}
._item_5ga25_1 ._content_5ga25_35 ._green_5ga25_101 span {
  color: #619622;
  font-weight: 600;
}
._item_5ga25_1 ._controls_5ga25_105 {
  min-width: 310px;
  max-width: 310px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 12px;
}
._item_5ga25_1 ._controls_5ga25_105 ._link_5ga25_116 {
  text-align: center;
}

._red_5ga25_89 {
  background: #f8dadb;
}

._orange_5ga25_97 {
  background: #fcf0e0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  